/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import SparkleIcon from "assets/icons/sparkle.svg";
import { cn } from "tailwind-variants";

export default function PinReadyCard({ instruction, compact = false, ...restProps }: any) {
  return (
    <div
      {...restProps}
      className={cn(
        "rounded-lg border border-[#A5B4FC] bg-white shadow-[0px_4px_6px_-2px_rgba(0,0,0,0.05)]",
        compact ? "p-2" : "p-4"
      )}
      data-testid="pin-ready-card"
    >
      <div className={cn("flex items-start", compact ? "gap-1.5" : "gap-3")}>
        <SparkleIcon
          className={cn("mt-0.5 shrink-0 text-[#6366F1]", compact ? "h-3.5 w-3.5" : "h-5 w-5")}
          data-testid="mt-0.5"
        />
        <div className={cn("flex flex-col", compact ? "gap-0.5" : "gap-1")}>
          <h4 className="m-0 text-xs font-bold uppercase tracking-wide text-[#6366F1]">
            {" "}
            OUR DESIGN TEAM WILL MAKE THE FOLLOWING EDIT AFTER CHECKOUT:{" "}
          </h4>
          <span className="whitespace-pre-wrap text-sm text-gray-700">{instruction}</span>
        </div>
      </div>
    </div>
  );
}
